
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AsnModule from "@/store/modules/asn";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";

import { AsnLevel } from "@/models/api/asn/asn";
import { AsnMap } from "@/models/api/asn/map";

const asnModule = getModule(AsnModule);


interface MapOption {
  label: string;
  value: string;
}

@Component({
  components:{
    Select
  }
})
export default class UploadAsnModal extends Vue {
    ASNLevel: AsnLevel = 0;
    ASNFile: File | null = null;
    HasHeader: boolean = true;
    HasBarcodes: boolean = false;

    SelectedMapId: MapOption = null;
    SelectedMap: AsnMap = null;
    AvailableMaps: AsnMap[] = [];
    MapOptions: MapOption[] = [];

    async onFileChange($event){
      for(let i = 0; i < $event.target.files.length; i++){
        this.ASNFile = $event.target.files[i];  
      }
    }
    
    async getAvailableMaps(){
      let maps = await asnModule.getMapList();

      if (maps !== null && maps !== undefined){
        this.AvailableMaps = maps;
        this.MapOptions = this.AvailableMaps.filter(x => x.asnLevel == this.ASNLevel).map(x => ({ label: x.displayName, value: x.id }));
      }

      this.MapOptions.push({ label: "(New Map)", value: null });

      if (this.SelectedMapId == null){
        this.SelectedMapId = { label: "(New Map)", value: null };
      }
    }

    @Watch("HasBarcodes")
    async selectedBarcodesChanged(newValue) {
      if (newValue){
        this.ASNLevel = AsnLevel.BarcodeLevel;
      }
      else {
        this.ASNLevel = AsnLevel.OrderLevel;
      }
    }

    @Watch("SelectedMapId")
    async selectedMapChanged(newValue) {
      if (newValue !== null && newValue !== undefined && newValue.value !== null){
        this.SelectedMap = this.AvailableMaps.find(x => x.id === newValue.value);
      }
      else {
        this.SelectedMap = null;
      }
    }

    @Watch("ASNLevel")
    async selectedLevelChanged(newValue){
      this.MapOptions = this.AvailableMaps.filter(x => x.asnLevel == this.ASNLevel).map(x => ({ label: x.displayName, value: x.id }));
      this.MapOptions.push({ label: "(New Map)", value: null });
      this.SelectedMapId = { label: "(New Map)", value: null };
    }

    async created() {
        await this.getAvailableMaps();
        this.SelectedMapId = { label: "(New Map)", value: null };
    }

    async onSubmit(){
      let response = await asnModule.postAsnUpload({
        hasHeaderRow: this.HasHeader,
        file: this.ASNFile,
        asnLevel: this.ASNLevel,
      });

      this.$emit('file-uploaded', response.id);

      if (this.SelectedMap === null){
        this.$emit('map-selected', { id: null, displayName: `New Map ${new Date().toLocaleDateString()}`, asnLevel: this.ASNLevel, json: null });
      }
      else {
        this.$emit('map-selected', { id: this.SelectedMap.id, displayName: this.SelectedMap.displayName, asnLevel: this.SelectedMap.asnLevel, json: this.SelectedMap.json  });
      }
    }
}

